import {Card, Layout} from 'antd';
import React, {Component} from 'react';
import moment from 'moment';
import {receptionDisplayText, tireExchangeDisplayText, tireReplacementDisplayText,} from '../../helper/displayTextHelper';
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";

const { Content } = Layout;

class RecapFragment extends Component{


  mergeAllServices = () => {
    const {createAppointmentRequest:{selectedOptions}, cart} = this.props;
    const services = [];
    if (cart){
      Array.prototype.push.apply(services, cart.items.map(i=>i.name))
    }
    if (selectedOptions){
      Array.prototype.push.apply(services, selectedOptions.map(i=>i.title))
    }
    return services.join(", ");
  }
  render() {
    const {
      intl:{formatMessage},
      dealer,
      vehicle,
      date,
      slot,
      reception,
      createAppointmentRequest,
      publicContext,
      cart
    } = this.props;
    const {tiresExchange, tireReplacement, selectedOptions, chosenMobility, estimatedTime=0, generalInformation} = createAppointmentRequest;

    const duration = moment.duration(estimatedTime+((cart && cart.duration) || 0), 'minutes');
    const receptionText = receptionDisplayText(reception);
    const tireReplacementText = tireReplacementDisplayText(formatMessage, tireReplacement);

    return (
      <Content
        style={{
          margin: 'auto',
          marginBottom: 50,
          backgroundColor: 'white',
          width: '100%',
        }}
      >
        <Card
          title={<h2>{formatMessage({id: 'customer.journey.step.summary'}).toUpperCase()}</h2>}
          bordered={false}
          style={{width: '100%'}}
        >
          <h3>{`${formatMessage({id: 'customer.journey.recap.dealer'})}`}</h3>
          <p>
            {dealer}
          </p>
          <h3>{`${formatMessage({id: 'customer.journey.recap.vehicle'})}`}</h3>
          <p>
            {vehicle}
          </p>
          {generalInformation.leasingCompany && generalInformation.leasingCompany.length > 0 ? (
            <React.Fragment>
              <h3>{`${formatMessage({id: 'customer.journey.recap.leasingCompany'})}`}</h3>
              <p>
                {generalInformation.leasingCompany}
              </p>
            </React.Fragment>
          ) : null}
          {generalInformation.vinVehicleModel && generalInformation.vinVehicleModel.length > 0 ? (
            <React.Fragment>
              <h3>{`${formatMessage({id: 'vehicle.model'})}`}</h3>
              <p>
                {generalInformation.vinVehicleModel}
              </p>
            </React.Fragment>
          ) : null}
          {generalInformation.mileage && generalInformation.mileage > 0 ? (
            <React.Fragment>
              <h3>{`${formatMessage({id: 'customer.journey.recap.mileage'})}`}</h3>
              <p>
                {`${generalInformation.mileage} km`}
              </p>
            </React.Fragment>
          ) : null}
          {generalInformation.plateNumber && generalInformation.plateNumber.length > 0 ? (
            <React.Fragment>
              <h3>{`${formatMessage({id: 'customer.journey.recap.plateNumber'})}`}</h3>
              <p>
                {generalInformation.plateNumber}
              </p>
            </React.Fragment>
          ) : null}
          {generalInformation.phoneNumber && generalInformation.phoneNumber.length > 0 ? (
            <React.Fragment>
              <h3>{`${formatMessage({id: 'placeholder.phone'})}`}</h3>
              <p>
                {generalInformation.phoneNumber}
              </p>
            </React.Fragment>
          ) : null}
          {duration.asMinutes() > 0 ? (
            <React.Fragment>
              <h3>{`${formatMessage({id: 'customer.journey.recap.estimatedTime'})}`}</h3>
              <p>
                {`${duration._data.hours > 0 ? `${duration._data.hours}h` : ''}${duration._data.minutes > 0 ? `${duration._data.minutes}m` : ''}`}
              </p>
            </React.Fragment>
          ) : null}
          {((selectedOptions && selectedOptions.length > 0) || publicContext.bookingToken) ? (
            <React.Fragment>
              <h3>{`${formatMessage({id: 'customer.journey.recap.services'})}`}</h3>
              <p>
                {this.mergeAllServices()}
              </p>
            </React.Fragment>
          ) : null}
          {tiresExchange && tiresExchange.type && tiresExchange.mode ? (
            <React.Fragment>
              <h3>{`${formatMessage({id: 'customer.journey.recap.tireExchangeTitle'})}`}</h3>
              <p>
                {tireExchangeDisplayText(formatMessage, tiresExchange.type, tiresExchange.mode)}
              </p>
            </React.Fragment>
          ) : null}
          {tireReplacementText ? (
            <React.Fragment>
              <h3>{`${formatMessage({id: 'customer.journey.recap.tireReplacementTitle'})}`}</h3>
              <p>
                {tireReplacementText}
              </p>
            </React.Fragment>
          ) : null}
          {chosenMobility ? (
            <React.Fragment>
              <h3>{`${formatMessage({id: 'customer.journey.recap.mobility'})}`}</h3>
              <p>
                {chosenMobility.mobilityOptionTitle}
              </p>
            </React.Fragment>
          ) : null}
          {date ? (
            <React.Fragment>
              <h3>{`${formatMessage({id: 'customer.journey.recap.date'})}`}</h3>
              <p>
                {moment(date).format('DD/MM/YYYY')}
              </p>
            </React.Fragment>
          ) : null}
          {slot ? (
            <React.Fragment>
              <h3>{`${formatMessage({id: 'customer.journey.recap.slot'})}`}</h3>
              <p>
                {`${moment(slot.startTime, 'hh:mm:ss').format('HH:mm')} - ${moment(slot.endTime, 'hh:mm:ss').format('hh:mm')}`}
              </p>
            </React.Fragment>
          ) : null}
          {receptionText ? (
            <React.Fragment>
              <h3>{`${formatMessage({id: 'customer.journey.recap.reception'})}`}</h3>
              <p>
                {formatMessage({id: receptionText})}
              </p>
            </React.Fragment>
          ) : null}
        </Card>
      </Content>
    );
  }
}

const mapDispatchToProps = dispatch => ({
});

const mapStateToProps = state => ({
  createAppointmentRequest: state.createAppointmentRequest,
  cart: state.customerPreJourneyInfo.preJourneyInfo && state.customerPreJourneyInfo.preJourneyInfo.services && state.customerPreJourneyInfo.preJourneyInfo.services.cart,
  publicContext: state.publicContext,

});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RecapFragment)
);



// WEBPACK FOOTER //
// ./src/public/journey1/fragments/RecapFragment.js